import { useEffect, useRef, useState } from "react";
import { StartDiscussionPop } from "./StartDiscussionPop";

type Props = {
    onStartDiscussion: () => void;
}

export const CommunityBanner = ({ onStartDiscussion }: Props) => {
    const bannerRef = useRef(null);
    const [showFloatingButton, setShowFloatingButton] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            setShowFloatingButton(!entry.isIntersecting); 
        } ,{ threshold: 0 });

        if (bannerRef.current) {
            observer.observe(bannerRef.current);
        }
        return () => observer.disconnect();
    }, []);

    return (
        <>
            <div ref={bannerRef} className="community-banner" style={{ background: "linear-gradient(180deg, rgba(0, 0, 0, 0.13) 0%, rgba(0, 0, 0, 0.65) 60.13%), url('/media/c_banner.png') lightgray 0px -634.1px / 100% 633.784% no-repeat" }}>
                <div className="community-content">
                    <div className="texts">
                        <h2>
                            Community
                        </h2>

                        <span>
                            You are among the world’s brightest minds. Here, the space is open for you to share, exchange, and grow—whether in open discussions or exclusive mastermind circles.
                        </span>
                    </div>

                    <button onClick={onStartDiscussion}>
                        Start Discussion
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" viewBox="0 0 14 4" fill="none">
                            <path d="M8.5 0.378906L12 3.38306H0" stroke="white"/>
                        </svg>
                    </button>
                </div>
            </div>

            {showFloatingButton && (
                <StartDiscussionPop 
                    onClick={onStartDiscussion}
                />
            )}
        </>
    )
}